import { api } from './client.js';
import type { ReportColumnMeta } from './reports.js';

/** 코드 붙여넣기 도구. 원본 item_*_check.php 계열. */
export interface LookupMeta {
  id: string;
  title: string;
  group: string;
  legacyPath: string;
  description?: string;
  inputLabel: string;
  inputPlaceholder?: string;
  keyType: 'number' | 'string';
  dateRange: boolean;
  reconcile?: { filterLabel: string; filterPlaceholder?: string };
  altKey?: { label: string; placeholder?: string };
  columns: ReportColumnMeta[];
  hasSimple: boolean;
  maxKeys: number;
  /** true 면 "엑셀 다운로드"(사진 포함) 단추가 하나 더 생긴다. */
  excelExport: boolean;
}

export interface LookupResult {
  id: string;
  title: string;
  columns: ReportColumnMeta[];
  rows: Record<string, unknown>[];
  missing: string[];
  requested: number;
}

/** 대조 모드의 결과 (원본 item_code_stock.php 계열) */
export interface ReconcileResult {
  id: string;
  title: string;
  columns: ReportColumnMeta[];
  missingFromInput: Record<string, unknown>[];
  notInDb: string[];
  matched: number;
  dbCount: number;
  inputCount: number;
}

export const lookupApi = {
  list: () => api.get<Omit<LookupMeta, 'columns' | 'hasSimple' | 'maxKeys' | 'inputLabel' | 'keyType'>[]>('/lookup'),
  meta: (id: string) => api.get<LookupMeta>(`/lookup/${id}/meta`),
  run: (
    id: string,
    keys: string,
    opts: {
      withoutOptions?: boolean;
      from?: string;
      to?: string;
      filter?: string;
      useAltKey?: boolean;
    } = {},
  ) => api.post<LookupResult>(`/lookup/${id}`, { keys, ...opts }),

  reconcile: (id: string, keys: string, filter: string) =>
    api.post<ReconcileResult>(`/lookup/${id}`, { keys, filter }),

  /**
   * 서버가 같은 조건으로 다시 조회해 CSV 를 만들어 준다. 브라우저는 결과를
   * 안 갖고 있어도 되고(신뢰 경계), 코드값 -> 사람이 읽는 말 변환도 서버가
   * reports 와 같은 규칙으로 해준다.
   */
  exportCsv: (
    id: string,
    keys: string,
    opts: { withoutOptions?: boolean; from?: string; to?: string; useAltKey?: boolean } = {},
  ) => api.postBlob(`/lookup/${id}/export`, { keys, ...opts }),

  /**
   * "사진 포함 엑셀" 내려받기. meta.excelExport 가 true 인 도구에서만 쓴다
   * (원본 item_soldout_check_exec.php 처럼 사진이 화면의 존재 이유인 도구).
   * CSV 와 달리 상품마다 CDN 사진을 실제로 내려받아 박아 넣으므로 더 걸린다.
   */
  exportExcel: (
    id: string,
    keys: string,
    opts: { withoutOptions?: boolean; from?: string; to?: string; useAltKey?: boolean } = {},
  ) => api.postBlob(`/lookup/${id}/export-excel`, { keys, ...opts }),
};
